import { useEffect, useState } from "react"

import { KEY_CODE } from "@shared/constants"
import { eventListener, store } from "@shared/modules"

export default function useMacroMessage() {
  const [macroMessage, setMacroMessage] = useState<string>("")

  useEffect(() => {
    eventListener()

    window.onhelp = () => {
      return false
    }

    const hotkeyEvent = (e: KeyboardEvent) => {
      if (
        !Object.values(KEY_CODE.Function).includes(e.keyCode) ||
        !store.local.get(`macro.${e.key}`)
      )
        return

      e.cancelBubble = true
      e.returnValue = false
      e.preventDefault()
      e.stopPropagation()
      setMacroMessage(store.local.get(`macro.${e.key}`))
      return
    }

    window.document.addEventListener("keydown", hotkeyEvent)

    return () => {
      window.document.removeEventListener("keydown", hotkeyEvent)
    }
  }, [])

  useEffect(() => {
    if (!macroMessage) return

    setMacroMessage("")
  }, [macroMessage])

  return macroMessage
}
